export const new_formula_date = new Date(Date.UTC(2020, 5, 6, 19, 0, 0)).getTime();
export const new_percentiles_date = new Date(Date.UTC(2020, 5, 13, 19, 27)).getTime();
export const unknown_player = "$unknown";  // "$" isn't an allowed character in names so this should be safe
